import React from 'react';

export default function TableLoadingSkeleton() {
	return (
		<div className="w-full h-20 border-2 dark:border-gray-300 border-gray-400 rounded-md mx-auto mt-3">
			<div className="flex animate-pulse flex-row items-center h-full justify-start ml-3 space-x-5">
				<div className="w-14 dark:bg-gray-300 bg-gray-500 h-12 rounded-full "></div>
				<div className="flex flex-col w-1/2 space-y-3">
					<div className="w-10/12 dark:bg-gray-300 bg-gray-500 h-6 rounded-md "></div>
					<div className="w-8/12 dark:bg-gray-300 bg-gray-500 h-6 rounded-md "></div>
				</div>
				<div className="flex flex-col w-1/2 space-y-3">
					<div className="w-10/12 dark:bg-gray-300 bg-gray-500 h-6 rounded-md "></div>
					<div className="w-3/12 dark:bg-gray-300 bg-gray-500 h-6 rounded-md "></div>
				</div>
			</div>
		</div>
	);
}
